import { useEffect, useContext, useState } from "react";
import { Button, Card, Skeleton } from "antd";
import HTTP from "../../services/httpService";
import { SettingContext } from "../../routes";
import CustomHeader from "../common/Header";
import { useNavigate } from "react-router-dom";
import {
    downloadCSV,
    formatDate,
    getUserRole,
    reviewTypes,
} from "../../services/util";
import moment from "moment";
import CustomTable from "../common/Table";
import { useQuery } from "react-query";

function ReviewsTable() {
    const staff_id = localStorage.getItem(`x-dashboard-staffid`);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const navigate = useNavigate();

    const {
        selectedDates,
        setSingleSelectedHotels,
        selectedHotels,
        kioskSelection,
    } = useContext(SettingContext);

    const hotel_ids = selectedHotels;
    const [start_date, end_date] = selectedDates;
    const [formData, setFormData] = useState({
        start_date: formatDate(start_date),
        end_date: formatDate(end_date),
        staff_id,
        page: 0,
        limit: 10,
        hotel_ids,
        all_selected: hotel_ids.length > 0 ? false : true,
        filters: {},
        calling_hotel_type: kioskSelection,
    });

    const {
        status: reviewStatus,
        data: reviewDataRes,
        refetch: fetchReviews,
    } = useQuery(
        "reviewsTable",
        async () => {
            return await HTTP("/reviews/getKioskReviews", { ...formData });
        },
        { enabled: false },
    );

    useEffect(() => {
        fetchReviews();
    }, []);
    useEffect(() => {
        fetchReviews();
    }, [formData]);

    useEffect(() => {
        setFormData({
            ...formData,
            calling_hotel_type: kioskSelection,
        });
    }, [kioskSelection]);

    useEffect(() => {
        const [start_date, end_date] = selectedDates;
        setFormData({
            ...formData,
            start_date: formatDate(start_date),
            end_date: formatDate(end_date),
        });
    }, [selectedDates]);

    useEffect(() => {
        const hotel_ids = selectedHotels;
        setFormData({
            ...formData,
            hotel_ids,
            page: 0,
            all_selected: hotel_ids.length === 0 ? true : false,
        });
    }, [selectedHotels]);

    useEffect(() => {
        if (reviewStatus === "success") {
            let { data: reviewsTableData, total } = reviewDataRes;
            if (reviewsTableData.length > 0) {
                reviewsTableData = reviewsTableData.map((e) => {
                    const guest_first_name =
                        e.guest_first_name !== "-" ? e.guest_first_name : "";
                    const guest_last_name =
                        e.guest_last_name !== "-"
                            ? e.guest_last_name
                            : guest_first_name === ""
                            ? "-"
                            : "";
                    e.guest_user = `${guest_first_name.trim()}  ${guest_last_name.trim()}`;
                    e.review_text = "-";
                    if (e.review === 1) {
                        e.review_text = "Poor";
                    } else if (e.review === 2) {
                        e.review_text = "Good";
                    } else if (e.review === 3) {
                        e.review_text = "Excellent";
                    }
                    e.review_date_time =
                        e.review_date === "-" || e.review_time === "-"
                            ? "-"
                            : moment(
                                  `${e.review_date} ${e.review_time}`,
                              ).format("YYYY/MM/DD HH:MM:SS");
                    return e;
                });
                setTableData(reviewsTableData);
            }
            setTotalRecords(total);
        }
    }, [reviewStatus, reviewDataRes]);

    function handleTableChange(pagination, filters, sorter, extra) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
            ...(filters?.review_text
                ? { filters: { review: [...filters.review_text] } }
                : { filters: {} }),
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        } else {
            delete formData.sorting;
            delete formData.sort_by;
        }
        const updatedFormData = { ...formData, ...others };
        updatedFormData.all_selected =
            updatedFormData.hotel_ids.length > 0 ? false : true;
        updatedFormData.start_date = formatDate(updatedFormData.start_date);
        updatedFormData.end_date = formatDate(updatedFormData.end_date);
        setFormData(updatedFormData);
    }

    const columns = [
        {
            title: "Hotel Name",
            dataIndex: "hotel_name",
            key: "hotel_name",
            sorter: () => {},
            fixed: "left",
            render: (text, record) => (
                <Button
                    type={"link"}
                    onClick={getReviewsGraph}
                    id={record.hotel_id}
                    hotelname={text}
                    style={{ padding: 0 }}
                >
                    {text}
                </Button>
            ),
        },
        {
            title: "Transaction ID ",
            dataIndex: "transaction_id",
            key: "transaction_id",
            sorter: () => {},
        },
        {
            title: "Room No.",
            dataIndex: "room_number",
            key: "room_number",
            sorter: () => {},
        },
        {
            title: "Guest User",
            dataIndex: "guest_user",
            key: "guest_user",
            sorter: () => {},
        },
        {
            title: "Staff User",
            dataIndex: "staff_name",
            key: "staff_name",
            sorter: () => {},
        },
        {
            title: "Date",
            dataIndex: "review_date_time",
            key: "review_date_time",
            sorter: () => {},
        },
        {
            title: "Reviews",
            dataIndex: "review_text",
            key: "review_text",
            filters: [
                ...reviewTypes.map((v) => {
                    return { text: v.name, value: v.key };
                }),
            ],
            width: "10%",
            sorter: () => {},
        },
        {
            title: "Sub Reviews",
            dataIndex: "sub_review",
            key: "sub_review",
            width: "10vw",
            sorter: () => {},
        },
    ];

    function getReviewsGraph(e) {
        const hotel_id = e.currentTarget.getAttribute("id");
        const hotel_name = e.currentTarget.getAttribute("hotelname");
        setSingleSelectedHotels(`${hotel_name}#${hotel_id}`);
        navigate(`/reviews-graph`, {
            state: {
                hotel_id,
            },
        });
    }

    async function downloadFile() {
        let { start_date, end_date, all_selected, hotel_ids, filters } =
            formData;
        start_date = moment(start_date).format(`YYYY-MM-DD`);
        end_date = moment(end_date).format(`YYYY-MM-DD`);
        /* let url = `/reviews/getKioskReviewsReport?start_date=${start_date}&end_date=${end_date}&hotel_ids=${
            hotel_ids.length === 0 ? `[]` : `[${hotel_ids.join()}]`
        }&staff_id=${staff_id}&all_selected=${all_selected}&filters=${JSON.stringify(
            filters,
        )}`; */
        const res = await HTTP(
            `/reviews/getKioskReviewsReport`,
            formData,
            // "GET",
        );
        downloadCSV(res, "reviews");
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") && (
                        <Button
                            className="margin-right-5"
                            type="primary"
                            disabled={totalRecords === 0}
                            onClick={downloadFile}
                        >
                            Download
                        </Button>
                    )
                }
            />
            <Card className="box-shadow margin-10">
                {reviewStatus === "loading" || reviewStatus === "idle" ? (
                    <Skeleton
                        active
                        title={false}
                        paragraph={{ rows: 20, width: 40 }}
                    />
                ) : (
                    <CustomTable
                        columns={columns}
                        tableData={tableData}
                        noOfrecords={totalRecords}
                        handleTableChange={handleTableChange}
                        rowKey="transaction_id"
                        className="review-table"
                        isScroll
                    />
                )}
            </Card>
        </Card>
    );
}

export { ReviewsTable };
